export default "__VITE_ASSET__BYA9bDwf__"